import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { Checkbox, FormHelperText, TextField } from '@material-ui/core';
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import FlexView from 'react-flexview/lib';
import { liabilityLimitPretty } from '../../services/utils';
import { useForm } from 'react-hook-form';

export const SpecialPricePopup = () => {
    const [open, setOpen] = React.useState(false);
    const {register, getValues, errors, triggerValidation} = useForm({mode: 'onChange'})

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleDisagree = () => {
        setOpen(false);
    };

    const handleAgree = async () => {

        let valid = await triggerValidation()

        if(!valid) return

        EventEmitterService.dispatch(EventKey.SPECIAL_POPUP_APPROVE, getValues())

        setOpen(false);
        
    };

    React.useEffect(() => {

        let id = EventEmitterService.subscribe(EventKey.SHOW_SPECIAL_PRICE_POPUP, () => {
            handleClickOpen()
        })

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.SHOW_SPECIAL_PRICE_POPUP, id)
        }
    }, [])

    return (
        <Dialog
            open={open}
            onClose={handleDisagree}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">Special Price</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Set a special liability price
                </DialogContentText>
                <DialogContentText id="alert-dialog-description">
                    <TextField inputRef={register({required: true})} type="number" 
                        autoFocus
                        label={'Special Price'} name="custom_premium" fullWidth variant="outlined" error={!!errors.custom_premium} helperText={!!errors.custom_premium && errors.custom_premium.type} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleDisagree} color="primary">
                Cancel
            </Button>
            <Button onClick={handleAgree} color="primary" autoFocus>
                Set
            </Button>
            </DialogActions>
        </Dialog>
    );
}